/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  completeBatch,
  getBatchForms,
  searchBatchForms,
  hideOwnershipModal,
  takeQueueItem,
  getFormPdf,
  showDeleteFormModal,
  hideDeleteFormModal,
  deleteBatchForm,
  showEditFormAssociationsModal,
  hideEditFormAssociationsModal,
  editBatchFormAssociations,
  getBatch
} from 'actions';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import BatchBreadcrumbs from 'components/BatchBreadcrumbs';
import BatchForms from 'components/BatchForms';
import ChangeOwnershipModal from 'components/Modals/ChangeOwnershipModal';
import ConfirmModal from 'components/Modals/ConfirmModal';
import DeleteFormModal from 'components/Modals/DeleteFormModal';
import EditFormAssociationsModal from 'components/Modals/EditFormAssociationsModal';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class BatchFormsContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.shape().isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    settings: PropTypes.shape(),
    permissions: PropTypes.arrayOf(PropTypes.string),
    isGettingBatchForms: PropTypes.bool.isRequired,
    batchForms: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      dateUploaded: PropTypes.string,
      folder: PropTypes.string,
      legalEntity: PropTypes.string,
      businessDivision: PropTypes.string,
      region: PropTypes.string,
      statusString: PropTypes.string,
      numberOfPacks: PropTypes.number,
      numberOfForms: PropTypes.number
    })),
    batchItem: PropTypes.shape(),
    batchFileItem: PropTypes.shape(),
    batchFormsCount: PropTypes.number,
    batchFormsPageNumber: PropTypes.number,
    batchFormsPageSize: PropTypes.number,
    changeOwnershipItem: PropTypes.shape(),
    isOwnershipModalShown: PropTypes.bool,
    isDeleteFormModalShown: PropTypes.bool,
    isDeletingForm: PropTypes.bool,
    deleteFormError: PropTypes.string,
    formsToDelete: PropTypes.shape(),
    isEditFormAssociationsModalShown: PropTypes.bool,
    currentForm: PropTypes.shape(),
    location: PropTypes.shape({
      key: PropTypes.string
    }).isRequired,
    isCompletingBatch: PropTypes.bool
  };

  static defaultProps = {
    settings: null,
    permissions: null,
    batchItem: null,
    batchFileItem: null,
    batchForms: null,
    batchFormsPageNumber: 1,
    batchFormsPageSize: 50,
    batchFormsCount: 0,
    isOwnershipModalShown: false,
    isDeleteFormModalShown: false,
    isDeletingForm: false,
    deleteFormError: null,
    formsToDelete: null,
    isEditFormAssociationsModalShown: false,
    currentForm: null,
    changeOwnershipItem: null,
    isCompletingBatch: false
  };

  constructor(props) {
    super(props);
    this.state = {
      searchQuery: null,
      selectionEnabled: false,
      currentPageNumber: props.batchFormsPageNumber,
      currentPageSize: props.batchFormsPageSize,
      isConfirmCompleteBatchModalShown: false,
      isConfirmEditFormAssociationsModalShown: false,
      associationChanges: null
    };
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillMount() {
    const {
      isAuthenticated,
      batchFormsPageNumber,
      batchFormsPageSize
    } = this.props;
    if (isAuthenticated) {
      this.fetchBatchForms(batchFormsPageNumber, batchFormsPageSize);
    }
  }

  shouldComponentUpdate({ location: { key: nextKey } }) {
    const {
      location: { key },
      batchFormsPageNumber,
      batchFormsPageSize,
    } = this.props;
    const updateComponent = key !== nextKey;
    if (updateComponent) {
      this.fetchBatchForms(batchFormsPageNumber, batchFormsPageSize);
    }
    return !updateComponent;
  }

  componentDidUpdate() {
    const { selectionEnabled } = this.state;
    if (this.batchFormsGrid) {
      this.batchFormsGrid.setSelectionVisibility(selectionEnabled);
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(hideOwnershipModal());
  }

  getCoverSheetMessage() {
    const {
      batchItem
    } = this.props;

    return (batchItem && batchItem.coverSheetJson)
      && (<div>Cover sheet available</div>);
  }

  getBatchFormAction(pageNumber, pageSize) {
    const {
      history: {
        location: { pathname }
      }
    } = this.props;
    let batchId = 0;
    let batchFileId = 0;
    let actionMethod;
    const path = pathname.split('/');
    if (path.length >= 2 && path.indexOf('batches') === 1) {
      batchId = path[2];
      if (path.length >= 4 && path.indexOf('files') === 3) {
        batchFileId = path[4];
      }
    }

    const { searchQuery } = this.state;
    let sortModel;
    let filters;

    if (this.batchFormsGrid) {
      sortModel = this.batchFormsGrid.getSortModel();
      filters = this.batchFormsGrid.getFilterModel();
    }

    const sortBy = (sortModel && sortModel[0]) ? sortModel[0].colId : '';
    const sortDirection = (sortModel && sortModel[0]) ? sortModel[0].sort : '';

    if (pageNumber === 'undefined' || !pageNumber) {
      pageNumber = 1;
    }
    if (pageSize === 'undefined' || !pageSize) {
      pageSize = 50;
    }

    let actionParameters = [batchId, batchFileId, pageNumber, pageSize, sortBy, sortDirection, filters];

    if (!searchQuery && !sortModel && !filters) {
      actionMethod = getBatchForms;
    } else {
      actionMethod = searchBatchForms;
      actionParameters = [...actionParameters, searchQuery];
    }

    return [actionMethod, actionParameters];
  }

  triggerSearch = () => {
    const { currentPageSize } = this.state;
    let { currentPageNumber } = this.state;
    currentPageNumber = 1;
    this.setState({ currentPageNumber });
    if (this.batchFormsGrid) {
      this.batchFormsGrid.resetPageNumber(currentPageNumber);
    }
    this.fetchBatchForms(currentPageNumber, currentPageSize);
  };

  fetchBatchForms(pageNumber, pageSize) {
    const {
      dispatch
    } = this.props;

    const refreshAction = this.getBatchFormAction(pageNumber, pageSize);
    if (refreshAction && refreshAction.length === 2) {
      dispatch(refreshAction[0](...refreshAction[1]));
    }
  }

  searchChanged(event) {
    clearTimeout(this.timer);
    const searchQuery = event.target.value;

    if (searchQuery.length > 0 && searchQuery.length < 2) {
      return;
    }

    this.setState({
      searchQuery
    });

    this.timer = setTimeout(this.triggerSearch, WAIT_INTERVAL);
  }

  searchInGrid(event) {
    clearTimeout(this.timer);
    const searchQuery = event.target.value;

    if (searchQuery.length > 0 && searchQuery.length < 2) {
      return;
    }

    this.setState({
      searchQuery
    });

    if (event.keyCode === ENTER_KEY) {
      this.triggerSearch();
    } else {
      this.timer = setTimeout(this.triggerSearch, WAIT_INTERVAL);
    }
  }

  changePage(paging) {
    this.setState({
      currentPageNumber: paging.number,
      currentPageSize: paging.size
    });
    this.fetchBatchForms(paging.number, paging.size);
    return true;
  }

  openConfirmCompleteBatchModal(confirmBatchItem) {
    this.setState({ isConfirmCompleteBatchModalShown: true, confirmBatchItem });
  }

  closeConfirmCompleteBatchModel() {
    this.setState({ isConfirmCompleteBatchModalShown: false });
  }

  completeBatch() {
    const { dispatch } = this.props;
    const { confirmBatchItem } = this.state;
    dispatch(completeBatch(confirmBatchItem.id, getBatch));
    this.setState({ isConfirmCompleteBatchModalShown: false });
  }

  fetchOriginalPdfFile(formId) {
    const { dispatch } = this.props;
    dispatch(getFormPdf({ id: formId, isAdditional: false }));
  }

  openConfirmEditFormAssociationsModal(selections) {
    this.setState({ isConfirmEditFormAssociationsModalShown: true, associationChanges: selections });
  }

  closeConfirmEditFormAssociationsModal() {
    this.setState({ isConfirmEditFormAssociationsModalShown: false });
  }

  openEditFormAssociationsModal(item) {
    const { dispatch } = this.props;
    dispatch(showEditFormAssociationsModal(item));
  }

  closeEditFormAssociationsModal(item) {
    const { dispatch } = this.props;
    dispatch(hideEditFormAssociationsModal());
  }

  openDeleteFormModal(item) {
    const { dispatch } = this.props;
    dispatch(showDeleteFormModal(item));
  }

  closeDeleteFormModal() {
    const { dispatch } = this.props;
    dispatch(hideDeleteFormModal());
  }

  deleteForm() {
    const { dispatch, history: { location: { pathname } }, formsToDelete: { formType, id } } = this.props;
    const { currentPageNumber, currentPageSize } = this.state;

    let batchId = 0;
    let batchFileId = 0;
    const path = pathname.split('/');
    if (path.length >= 2 && path.indexOf('batches') === 1) {
      batchId = path[2];
      if (path.length >= 4 && path.indexOf('files') === 3) {
        batchFileId = path[4];
      }
    }
    dispatch(deleteBatchForm(batchId, batchFileId, formType, id, currentPageNumber, currentPageSize));
  }

  processEditFormAssociations() {
    const { dispatch, currentForm: { id }, history: { location: { pathname } } } = this.props;
    const { currentPageNumber, currentPageSize, associationChanges } = this.state;

    let batchId = 0;
    let batchFileId = null;
    const path = pathname.split('/');
    if (path.length >= 2 && path.indexOf('batches') === 1) {
      batchId = path[2];
      if (path.length >= 4 && path.indexOf('files') === 3) {
        batchFileId = path[4];
      }
    }

    dispatch(editBatchFormAssociations(id, associationChanges, currentPageNumber, currentPageSize, batchId, batchFileId));
    this.closeConfirmEditFormAssociationsModal();
  }

  reAssignItem() {
    const { dispatch, changeOwnershipItem } = this.props;

    if (changeOwnershipItem != null && changeOwnershipItem.id != null) {
      dispatch(takeQueueItem('form', changeOwnershipItem.id, changeOwnershipItem.accountId));
      dispatch(hideOwnershipModal());
    }
  }

  refreshList() {
    const { dispatch } = this.props;
    const { currentPageNumber, currentPageSize } = this.state;
    const refreshAction = this.getBatchFormAction(currentPageNumber, currentPageSize);
    if (refreshAction) {
      dispatch(refreshAction[0](...refreshAction[1]));
    }
  }

  continueFromOwnershipModal() {
    const { dispatch, history, changeOwnershipItem } = this.props;
    dispatch(hideOwnershipModal());
    let redirectUrl = `/forms/${ changeOwnershipItem.formType.toLowerCase() }/${ changeOwnershipItem.id }`;
    if (changeOwnershipItem.accountId) {
      redirectUrl = `${ redirectUrl }?account=${ changeOwnershipItem.accountId }`;
    }
    history.push(redirectUrl);
  }

  closeFromOwnershipModal() {
    const { dispatch } = this.props;
    dispatch(hideOwnershipModal());
  }

  render() {
    const {
      settings,
      permissions,
      isGettingBatchForms,
      batchItem,
      batchFileItem,
      batchForms,
      batchFormsCount,
      isOwnershipModalShown,
      isDeleteFormModalShown,
      isDeletingForm,
      deleteFormError,
      changeOwnershipItem,
      isEditFormAssociationsModalShown,
      isCompletingBatch
    } = this.props;

    const {
      isConfirmEditFormAssociationsModalShown,
      isConfirmCompleteBatchModalShown,
      confirmBatchItem
    } = this.state;

    return (
      <div className="container home-page-panel">
        <div className="panel col-12 batches-panel">
          <div className="panel-header">
            <div className="panel-title">
              Uploaded Batch Forms
              { batchItem && (<BatchBreadcrumbs batchId={ batchItem.id } batchDisplayId={ batchItem.batchId } batchFileName={ batchFileItem && batchFileItem.originalFileName } />) }
            </div>
            { this.getCoverSheetMessage() }
            <div>
              <div className="tool-panel">
                <div className="controls-group">
                  <div className="input-group">
                    { !batchFileItem && AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
                    && batchItem && batchItem.statusString === 'Processed' && batchItem.numberOfUnassignedForms === 0 && <button
                      type="button"
                      className="btn btn-primary mr"
                      onClick={
                        () => this.openConfirmCompleteBatchModal(batchItem)
                      }
                    >
                      Complete Batch
                    </button> }
                    <input
                      type="search"
                      className="form-input"
                      placeholder="Search Batch Forms..."
                      onKeyUp={ e => this.searchInGrid(e) }
                      onChange={ e => this.searchChanged(e) }
                    />
                    <span className="input-group-addon">
                      <span className="icon icon-search" />
                    </span>
                    <button id="refresh-button" type="button" className="btn ml" onClick={ () => this.refreshList() }>
                      <span className="icon icon-refresh" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="panel-body">
            { batchItem && <BatchForms
              settings={ settings }
              permissions={ permissions }
              ref={ (ref) => { this.batchFormsGrid = ref; } }
              isLoading={ isGettingBatchForms }
              rowData={ batchForms }
              totalCount={ batchFormsCount }
              changePageCallback={ batchForm => this.changePage(batchForm) }
              getOriginalPdfFileCallback={ form => this.fetchOriginalPdfFile(form) }
              editFormAssociationsCallback={ form => this.openEditFormAssociationsModal(form) }
              deleteFormCallback={ form => this.openDeleteFormModal(form) }
              batchItem={ batchItem }
            /> }
          </div>
        </div>

        { isDeleteFormModalShown && <DeleteFormModal
          isShown={ isDeleteFormModalShown }
          isDeletingForm={ isDeletingForm }
          onConfirmDelete={ () => this.deleteForm() }
          onCancel={ () => this.closeDeleteFormModal() }
          deleteFormError={ deleteFormError }
        /> }

        { changeOwnershipItem != null && <ChangeOwnershipModal
          isShown={ isOwnershipModalShown }
          onAssign={ () => this.reAssignItem() }
          onContinueWithoutAssign={ () => this.continueFromOwnershipModal() }
          onCancel={ () => this.closeFromOwnershipModal() }
          workflowRecord={ changeOwnershipItem }
        /> }

        { isEditFormAssociationsModalShown && <EditFormAssociationsModal
          isShown={ isEditFormAssociationsModalShown }
          onCancel={ () => this.closeEditFormAssociationsModal() }
          onConfirmFormAssociations={ selections => this.openConfirmEditFormAssociationsModal(selections) }
        /> }

        { isConfirmCompleteBatchModalShown && <ConfirmModal
          key="completeBatch"
          isShown={ isConfirmCompleteBatchModalShown }
          isPerformingAction={ isCompletingBatch }
          onConfirm={ () => this.completeBatch() }
          onCancel={ () => this.closeConfirmCompleteBatchModel() }
          title="Confirm Complete Batch"
          message={ `Are you sure you want to complete the batch ${ confirmBatchItem.batchId }?` }
        /> }

        { isConfirmEditFormAssociationsModalShown && <ConfirmModal
          key="editFormAssociations"
          isShown={ isConfirmEditFormAssociationsModalShown }
          isPerformingAction={ isCompletingBatch }
          onConfirm={ () => this.processEditFormAssociations() }
          onCancel={ () => this.closeConfirmEditFormAssociationsModal() }
          title="Confirm Change of Form Associations"
          message="Are you sure you want to change the customer / account(s) associated to this form?"
        /> }
      </div>
    );
  }
}

function mapStateToProps(state) {
  if (!state.auth) {
    return {};
  }

  const {
    auth: {
      isAuthenticated,
      settings,
      permissions
    },
    batches: {
      batchItem,
      isCompletingBatch
    },
    batchForms: {
      batchItem: batchItemFromForms,
      isGettingBatchForms,
      batchFileItem,
      batchForms,
      batchFormsCount,
      editLegalEntityError
    },
    forms: {
      isDeleteFormModalShown,
      isDeletingForm,
      deleteFormError,
      formsToDelete,
      isEditFormAssociationsModalShown,
      currentForm
    },
    workflow: {
      isOwnershipModalShown,
      changeOwnershipItem
    }
  } = state;

  return {
    batchItem: (batchItem && batchItemFromForms && batchItem.id === batchItemFromForms.id && batchItem) || batchItemFromForms,
    isAuthenticated,
    settings,
    permissions,
    isGettingBatchForms,
    batchFileItem,
    batchForms,
    batchFormsCount,
    editLegalEntityError,
    isOwnershipModalShown,
    changeOwnershipItem,
    isDeleteFormModalShown,
    isDeletingForm,
    deleteFormError,
    formsToDelete,
    isEditFormAssociationsModalShown,
    currentForm,
    isCompletingBatch
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(BatchFormsContainer, 'BatchFormsContainer')));
